/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const overviewFiltersInputDataSortSchema = z.enum([
	'created_at',
	'name',
	'candidates',
	'hires',
	'cost_per_candidate',
])

export type OverviewFiltersInputDataSortSchema = z.infer<typeof overviewFiltersInputDataSortSchema>
